import type { Analytics, ApiResponse } from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class AnalyticsService {
  async getAnalytics(): Promise<ApiResponse<Analytics>> {
    return apiManager.get<Analytics>('/api/v1/admin/analytics');
  }
}

export const analyticsService = new AnalyticsService();